import React        from 'react'
import { Link }     from 'react-router-dom'
import { Progress } from 'antd'
import prettysize   from '../../../utils'

import './index.scss'

export default ({quota, has_billing_info, open_request_limit_extension, role}) => {
  let { fc, encoding, s3_native, wasabi, s3_acceleration, c2c } = (quota||{fc:{}, encoding:{}, s3_native:{}, wasabi:{}, s3_acceleration:{}, c2c:{}})

  if(fc && fc.trial)
    fc = fc.trial
  else
    fc ={}
  if(encoding && encoding.trial)
    encoding = encoding.trial
  else
    encoding ={}
  if(s3_native && s3_native.trial)
    s3_native = s3_native.trial
  else
    s3_native ={}
  if(wasabi && wasabi.trial)
    wasabi = wasabi.trial
  else
    wasabi ={}
  if(s3_acceleration && s3_acceleration.trial)
    s3_acceleration = s3_acceleration.trial
  else
    s3_acceleration ={}

  if(c2c && c2c.trial)
    c2c = c2c.trial
  else
    c2c ={}

  let fc_percent              = fc.total              === -1 ? -1 : ((100 * fc.used)/fc.total)
  let s3_acceleration_percent = s3_acceleration.total === -1 ? -1 : ((100 * s3_acceleration.used)/s3_acceleration.total)
  let encoding_percent        = encoding.total        === -1 ? -1 : ((100 * encoding.used)/encoding.total)
  let s3_native_percent       = s3_native.total       === -1 ? -1 : ((100 * s3_native.used)/s3_native.total)
  let wasabi_percent          = wasabi.total          === -1 ? -1 : ((100 * wasabi.used)/wasabi.total)
  let c2c_percent             = c2c.total             === -1 ? -1 : ((100 * c2c.used)/c2c.total)

  return (
    <div className='usage-card round-corner'>
    <div className="header">
      <p className='text'>Your plan usage</p>
      <Link to='/pricings'> See your plan details </Link>
    </div>
    <div className="content">
      <div>
        <span>S3 Direct <span>({prettysize(s3_native.used)} of {prettysize(s3_native.total)} used)</span></span>
        <Progress size="small" percent={s3_native_percent < 1 ? 2 : s3_native_percent} status={s3_native_percent < 3 ? 'success' : (s3_native_percent > 80 ? 'exception' : '')}/>
      </div>

      <div>
        <span>S3 Accelerated <span>({prettysize(s3_acceleration.used)} {(' of ' + (s3_acceleration.total === -1 ? 'Unlimited' : (prettysize(s3_acceleration.total) + ' used')))})</span></span>
        <Progress size="small" percent={has_billing_info ? 0 : (s3_acceleration_percent < 1 ? 2 : s3_acceleration_percent)} status={has_billing_info ? 'success' : (s3_acceleration_percent < 3 ? 'success' : (s3_acceleration_percent > 80 ? 'exception' : null))}/>
      </div>

      {/*<div>
        <span>FileCatalyst <span>({prettysize(fc.used)} {(' of ' + ( fc.total === -1 ? 'Unlimited' : (prettysize(fc.total)+ ' used')))})</span></span>
        <Progress size="small" percent={has_billing_info ? 0 : (fc_percent < 1 ? 2 : fc_percent)} status={has_billing_info ? 'success' : (fc_percent < 3 ? 'success' : (fc_percent > 80 ? 'exception' : null))}/>
      </div>*/}

      {/*<div>
        <span>Encoding <span>({prettysize(encoding.used)} {(' of ' + ( encoding.total === -1 ? 'Unlimited' : (prettysize(encoding.total)+ ' used')))})</span></span>
        <Progress size="small" percent={has_billing_info ? 0 : (encoding_percent < 1 ? 2 : encoding_percent)} status={has_billing_info ? 'success' : (encoding_percent < 3 ? 'success' : (encoding_percent > 80 ? 'exception' : null))}/>
      </div>*/}


      {/*<div>
        <span>Wasabi <span>({prettysize(wasabi.used)} of {prettysize(wasabi.total)} used)</span></span>
        <Progress size="small" percent={wasabi_percent < 1 ? 2 : wasabi_percent} status={wasabi_percent < 3 ? 'success' : (wasabi_percent > 80 ? 'exception' : '')}/>
      </div>

      <div>
        <span>Encoding <span>({prettysize(encoding.used)} of {prettysize(encoding.total)} used)</span></span>
        <Progress size="small" percent={encoding_percent < 1 ? 2 : encoding_percent} status={encoding_percent < 3 ? 'success' : (encoding_percent > 80 ? 'exception' : '')}/>
      </div>*/}

      <div>
        <span>Cloud to Cloud <span>({prettysize(c2c.used)} {(' of ' + (c2c.total === -1 ? 'Unlimited' : (prettysize(c2c.total) + ' used')))})</span></span>
        <Progress size="small" percent={has_billing_info ? 0 : (c2c_percent < 1 ? 2 : c2c_percent)} status={has_billing_info ? 'success' : (c2c_percent < 3 ? 'success' : (c2c_percent > 80 ? 'exception' : null))}/>
      </div>
    </div>
    <div className="footer">
      <p className='text'>
        {/*<span> {prettysize(10240)} of {prettysize(10240)}</span>*/}
      </p>
      {
        (role.title !== 'Owner') ?
          <button onClick={open_request_limit_extension}>Request limit extension</button>: null
      }
    </div>
  </div>
  )
}
